const GET_PRMS_REQUEST = 'GET_PRMS_REQUEST';
const GET_PRMS_SUCCESS = 'GET_PRMS_SUCCESS';
const GET_PRMS_ERROR = 'GET_PRMS_ERROR';

const DELETE_PRM_REQUEST = 'DELETE_PRM_REQUEST';
const DELETE_PRM_SUCCESS = 'DELETE_PRM_SUCCESS';
const DELETE_PRM_ERROR = 'DELETE_PRM_ERROR';

const CLEAR_PRMS_STATE = 'CLEAR_SCANNED_DOCUMENTS_STATE';
const CLEAR_ERRORS = 'CLEAR_ERRORS';
const CLEAR_ERRORS_PROFILE = 'CLEAR_ERRORS_PROFILE';
const INIT_REDUCER = 'INIT_REDUCER';
const CREATE_ERRORS = 'CREATE_ERRORS';

export {
  GET_PRMS_REQUEST,
  GET_PRMS_SUCCESS,
  GET_PRMS_ERROR,
  DELETE_PRM_REQUEST,
  DELETE_PRM_SUCCESS,
  DELETE_PRM_ERROR,
  CLEAR_PRMS_STATE,
  CLEAR_ERRORS,
  CLEAR_ERRORS_PROFILE,
  CREATE_ERRORS,
  INIT_REDUCER,
};
